import type { FC, ReactNode } from "react";
import { useAdminSidebarStyles } from "./adminSidebar.styles";

interface IAdminSidebarGroupProps {
  name: string;
  children: ReactNode;
}

export const AdminSidebarGroup: FC<IAdminSidebarGroupProps> = ({
  name,
  children,
}) => {
  const styles = useAdminSidebarStyles();

  return (
    <div className={styles.groupContainer} role="group" aria-label={name}>
      <div className={styles.groupHeader}>{name}</div>
      {children}
    </div>
  );
};
